import { useSelector } from 'react-redux';

import { CircularProgress, Box } from '@mui/material';

import { selectIsLoading } from './loadingSlice';

export const StaticLoader = () => (
	<Box
		sx={{
			position: 'fixed',
			top: 0,
			left: 0,
			right: 0,
			bottom: 0,
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			backgroundColor: 'rgba(255, 255, 255, 0.7)',
			zIndex: 9999,
		}}
	>
		<CircularProgress sx={{ color: '#BE3327' }} />
	</Box>
);

export const LoadingIndicator: React.FC = () => {
	const isLoading = useSelector(selectIsLoading);

	if (!isLoading) return null;

	return <StaticLoader />;
};

export default LoadingIndicator;
